<template>
  <div class="app">
    <el-container>
      <el-header>
        <AppHeader></AppHeader>
      </el-header>

      <el-container class="defaultContainer__container">
        <div class="main__container">
          <AppAside @DoCollapse="DoCollapseAppAside"></AppAside>

          <div :class="containerClass">
            <div class="nav">
              <AppNav></AppNav>
            </div>

            <div class="page__view">
              <router-view></router-view>
            </div>
          </div>
        </div>
      </el-container>
    </el-container>
  </div>
</template>

<script>

export default {
  name: "DefaultContainer",
  components: {
  },
  data() {
    return {
      collapse: false,
    };
  },
  methods: {
    DoCollapseAppAside() {
      this.collapse = !this.collapse;
    }
  },
  computed: {
    name() {
      return this.$route.name;
    },
    containerClass() {
      if (this.collapse) {
        return "container-fluid--collapse";
      } else {
        return "container-fluid";
      }
    }
  }
};
</script>
